// Stop all videos on modal close
$('#modalVideo').on('hidden.bs.modal', function () {
  var videos = document.querySelectorAll('iframe, video');
  Array.prototype.forEach.call(videos, function (video) {
    if (video.tagName.toLowerCase() === 'video') {
      video.pause();
    } else {
      var src = video.src;
      video.src = src;
    }
  });
});


// focus when search field is shown
$(function(){
  
  $('#mainSearch, #mainSearchMobile').on('shown.bs.collapse', function(){
    $(this).find('input[type="text"]').focus();
    $(this).find('input[type="text"]').click();
  });

});

// scroll top button
$(window).on('scroll', function(){
  if ( $(window).scrollTop() > 500 )
  {
    $('.ButtonScrollUp').addClass('ButtonScrollUp-shown');
  }
  else
  {
    $('.ButtonScrollUp').removeClass('ButtonScrollUp-shown');
  }
});

$('.ButtonScrollUp').on('click', function(e){
  e.preventDefault();

  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

// utils
window.utils = {
  setQueryStringParameter(name, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(name, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
  },
  getQueryStringParameter(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
};